import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  frontendSkillsReducer,
  backendSkillsReducer,
  toolSkillsReducer,
  communicationSkillsReducer,
  softSkillsReducer,
  allProjectsReducer,
  allTestimonialsDataReducer,
} from './reducers/reducers';

const rootReducer = combineReducers({
  frontendskills: frontendSkillsReducer,
  backendskills: backendSkillsReducer,
  toolskills: toolSkillsReducer,
  communicationskills: communicationSkillsReducer,
  softskills: softSkillsReducer,
  projects: allProjectsReducer,
  testimonials: allTestimonialsDataReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
